import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";
import { fetchCurrentUserData } from "@/util/customFetch";

export async function getInventoryItemQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/inventory/item/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function postInventoryPartCreate(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/inventory/item/new', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function putInventoryPartEdit(partId, requestBody, headers) {
  // removing these 2 keys as they should not be edited directly.
  delete requestBody.on_order
  delete requestBody.on_hand
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/inventory/item?id=${partId}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function postOnHandRecordCreate(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/inventory/on_hand_record/new`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getOnHandRecordsQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/inventory/on_hand_record/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function postPartConsumptionSubmit(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/inventory/partconsumption/new', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}


export async function getInventoryCategoryQuery(query, headers){
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    let url = BACKEND_API_PLACEHOLDER + '/api/inventory/category/query?'
    for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
      if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
    }
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }

export async function putInventoryCategoryEdit(categoryId, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/inventory/category?id=${categoryId}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function postInventoryCategoryCreate(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/inventory/category/new`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}